const siteAndDuration=[

    {
    label:"Site(s)",
    controlType:"text",
    options:[]
    },

    { 
    label:"Present for several:",
    controlType:"radio button",
    options:["Days", "Weeks","Months","Years"]
    }
]

export default siteAndDuration